"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.group = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const openapi_1 = require("../../../../openapi");
const Common = __importStar(require("../common"));
const System = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.System.Catalog';
const identifierOf = (schema) => effect_1.Option.getOrThrowWith(effect_1.SchemaAST.getIdentifierAnnotation(schema.ast), () => new globalThis.Error(`${exports.NAMESPACE}: catalogue items need an identifier annotation`));
// Query structs intentionally have no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const IdQuery = effect_1.Schema.Struct({
    id: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: 'Identifier of the entry' }),
});
const UniqueIdAndNameQuery = effect_1.Schema.Struct({
    id: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }).annotations({
        description: 'Id to test. At least one of id and name is required.',
    }),
    name: effect_1.Schema.optionalWith(effect_1.Schema.NonEmptyString, { exact: true }).annotations({
        description: 'Name to test. At least one of id and name is required.',
    }),
});
const UniqueNameQuery = effect_1.Schema.Struct({
    name: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: 'Name to test' }),
});
const errors = (protocol) => protocol === 'v1'
    ? {
        validation: openapi_1.Error.V1LegacyValidation,
        notFound: openapi_1.Error.V1NotFound,
        standard: openapi_1.Error.withV1StandardErrors,
    }
    : {
        validation: openapi_1.Error.Validation,
        notFound: openapi_1.Error.NotFound,
        standard: openapi_1.Error.withLegacyV2StandardErrors,
    };
/** One catalogue group. */
const group = (options) => {
    const itemIdentifier = identifierOf(options.item);
    const { validation, notFound, standard } = errors(options.protocol);
    const bodies = options.protocol === 'v1'
        ? 'The controller answers protocol v1 bodies.'
        : 'The controller answers typed protocol bodies.';
    const uniqueValidation = errors(options.uniqueProtocol ?? options.protocol).validation;
    const uniqueBodies = options.uniqueProtocol !== undefined && options.uniqueProtocol !== options.protocol
        ? `The query is validated by the shared express-validator chain, which answers protocol ${options.uniqueProtocol} bodies (422 \`INVALID_REQUEST\`); otherwise ${bodies.charAt(0).toLowerCase()}${bodies.slice(1)}`
        : bodies;
    const List = effect_1.Schema.Struct({ items: effect_1.Schema.Array(options.item) }).annotations({
        identifier: `${itemIdentifier}List`,
        description: `Every ${options.subject} definition`,
    });
    const plural = options.plural ?? `${options.kind}s`;
    const list = platform_1.HttpApiEndpoint.get(`list${plural}`) `/list`
        .addSuccess(openapi_1.Response.Success(List).annotations({ description: `List of ${options.subject}s` }))
        .annotate(platform_1.OpenApi.Title, `List ${plural}`)
        .annotate(platform_1.OpenApi.Description, `Returns every ${options.subject} definition. ${bodies}`)
        .pipe(options.listGuard ?? Common.withSystemAdminGuard, standard);
    const uniqueResult = options.unique === 'name'
        ? openapi_1.Response.Success(System.NameUniqueness).annotations({
            description: 'Whether the name is unused',
        })
        : openapi_1.Response.Success(System.Uniqueness).annotations({
            description: 'Whether the id and/or the name are unused',
        });
    const unique = platform_1.HttpApiEndpoint.get(`is${options.kind}Unique`) `/unique`
        .setUrlParams(options.unique === 'name' ? UniqueNameQuery : UniqueIdAndNameQuery)
        .addSuccess(uniqueResult)
        .addError(uniqueValidation)
        .annotate(platform_1.OpenApi.Title, `Is ${options.kind} Unique`)
        .annotate(platform_1.OpenApi.Description, options.unique === 'name'
        ? `Tells whether no ${options.subject} has the given name. ${uniqueBodies}`
        : `Tells whether no ${options.subject} has the given id and/or name; only the fields asked for are answered. ${uniqueBodies}`)
        .pipe(Common.withSystemAdminGuard, standard);
    const getBase = platform_1.HttpApiEndpoint.get(`get${options.kind}`) ``
        .setUrlParams(IdQuery)
        .addSuccess(openapi_1.Response.Success(options.item).annotations({ description: `The ${options.subject}` }))
        .addError(validation)
        .annotate(platform_1.OpenApi.Title, `Get ${options.kind}`);
    const get = ('message' in options.notFound
        ? getBase
            .addError(notFound)
            .annotate(platform_1.OpenApi.Description, `Returns one ${options.subject} definition by id; 404 \`${options.notFound.message}\` when it does not exist. ${bodies}`)
        : getBase.annotate(platform_1.OpenApi.Description, `Returns one ${options.subject} definition by id. ${bodies} Known runtime quirk: ${options.notFound.quirk}`)).pipe(Common.withSystemAdminGuard, standard);
    return platform_1.HttpApiGroup.make(options.id)
        .add(list)
        .add(unique)
        .add(get)
        .prefix(options.prefix)
        .annotate(platform_1.OpenApi.Title, options.title)
        .annotate(platform_1.OpenApi.Description, options.description)
        .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.System));
};
exports.group = group;
//# sourceMappingURL=catalog.js.map